/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventTooltipViewedFromJSON(json) {
    return StreemApiAnalyticEventTooltipViewedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventTooltipViewedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tooltipId': !exists(json, 'tooltip_id') ? undefined : json['tooltip_id'],
    };
}
export function StreemApiAnalyticEventTooltipViewedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tooltip_id': value.tooltipId,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventTooltipViewed.js.map